export function setActiveBySelector(activeSelector: string, groupSelector: string) {
  const activeButton = document.querySelector<HTMLButtonElement>(activeSelector);
  if (activeButton) {
    setActive(groupSelector, activeButton);
  }
}

export function setActive(selector: string, activeButton: HTMLButtonElement) {
  document.querySelectorAll<HTMLButtonElement>(selector).forEach((button) => {
    const isActive = button === activeButton;
    button.classList.toggle('active', isActive);
    button.setAttribute('aria-pressed', String(isActive));
  });
}
